import React, {useContext, useEffect} from 'react';
import {Link} from 'react-router-dom'

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid';
import { DataGrid } from '@mui/x-data-grid';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import dayjs from 'dayjs';

import * as CustomStyles from '../styles/CustomStyles';
import * as TypeConvertor from '../util/TypeConvertor';
import * as Formatter from '../util/Formatter';
import * as DataPattern from '../constants/DataPattern';

const columns = [
    {
        field: 'cnp',
        headerName: 'CNP',
        width: 150,
        valueGetter: (params) => params.row.cnp,
        renderCell: (params) => {
            return(
                <Link to={`/employees/${params.row.employeeId}?employerId=${params.row.employerId}`}>
                    {params.row.cnp}
                </Link>
            );
        }
    },
    {
        field: 'lastName',
        headerName: 'Nume',
        width: 150,
        valueGetter: (params) => params.row.lastName
    },
    {
        field: 'firstName',
        headerName: 'Prenume',
        width: 150,
        valueGetter: (params) => params.row.firstName
    },
    {
        field: 'ocupatiaCOR',
        headerName: 'Ocupatia (COR)',
        width: 300,
        valueGetter: (params) => params.row.occupationCORdescription
    },
    {
        field: 'certificateNo',
        headerName: 'Nr. Adeverinta',
        width: 200,
        valueGetter: (params) => params.row.certificateNo
    },
    {
        field: 'dateCertificate',
        headerName: 'Data Adeverinta',
        width: 120,
        valueGetter: (params) => params.row.dateCertificate ? params.row.dateCertificate : '',
        renderCell: (params) => {
            return( Formatter.formatDatetoRO(params.row.dateCertificate) );
        }
    },
    {
        field: 'certificateType',
        headerName: 'Categorie Personal',
        width: 200,
        valueGetter: (params) => TypeConvertor.getAuthzInternalName(params.row.authInternal)
    },
    {
        field: 'certificateExpiryDate',
        headerName: 'Scadenta Adeverinta',
        width: 120,
        valueGetter: (params) => params.row.dateMaturity ? params.row.dateMaturity : '',
        renderCell: (params) => {
            return(
                <Typography variant="body2" color={getDateTextColor(params.row.dateMaturity)}>
                    {Formatter.formatDatetoRO(params.row.dateMaturity)}
                </Typography>
            );
        }
    },
    {
        field: 'statusEmployee',
        headerName: 'Status Angajat',
        width: 200,
        valueGetter: (params) => TypeConvertor.getCimStatusName(params.row.employeeContractStatus)
    }
]

const referencefDate = dayjs().format(DataPattern.DATE_FORMAT_ISO);

const getDateTextColor = (dateToDisplay) => {
    var textColor = "text.primary";

    if(dateToDisplay) {
        if( referencefDate.localeCompare(dateToDisplay.substring(0,10)) <= 0) {
            textColor = "text.primary";
        }
        else {
            textColor = "error.main";
        }
    }

    return textColor;
}



const ReportAuthzInternal = (props) => {
    console.log('___ ReportAuthzInternal ___');

    useEffect(() => {
        console.log('Use Effect!!!');
        setReport(props.report)
        setReportEmployerName(props.reportEmployerName);
        setReportWorksiteName(props.reportWorksiteName);
    }, [props.report, props.reportEmployerName, props.reportWorksiteName]);

    const [report, setReport] = React.useState(props.report);
    const [reportEmployerName, setReportEmployerName] = React.useState(props.reportEmployerName);
    const [reportWorksiteName, setReportWorksiteName] = React.useState(props.reportWorksiteName);

    const downloadRaport = () => {
        console.log('download');

        var csv_data = generateCsvData();

        // Create CSV file object and feed our
        // csv_data into it
        const CSVFile = new Blob([csv_data], { type: "text/csv" });
    
        // Create to temporary link to initiate
        // download process
        var temp_link = document.createElement('a');
    
        // Download csv file
        temp_link.download = "Raport-authz-interne-" + reportWorksiteName.replace(/ /g, "-").replace(/,/g, "") + ".csv";
        var url = window.URL.createObjectURL(CSVFile);
        temp_link.href = url;
    
        // This link should not be displayed
        temp_link.style.display = "none";
        document.body.appendChild(temp_link);
    
        // Automatically click the link to trigger download
        temp_link.click();
        document.body.removeChild(temp_link);        
    }

    const generateCsvData = () => {

        var csv_data = [];
        const csvEmpty = ['', '', '', '', '', '', '', '', '', '', '', '', '', ''];
        const csvHeader = ['CNP', 'Nume', 'Prenume', 'Ocupatia (COR)', 'Nr. Adeverinta', 'Data Adeverinta', 'Categorie Personal', 'Scadenta Adeverinta', 'Status Anggajat'];
        
        csv_data.push(csvEmpty.join(","));                 // Combine each column value with comma

        var employerLine = ['Nume Angajator', reportEmployerName];
        csv_data.push(employerLine.join(","));

        var worksiteLine = ['Punct de lucru', reportWorksiteName];
        csv_data.push(worksiteLine.join(","));

        var authzTypeLine = ['Tip Autorizatii', 'Interne'];
        csv_data.push(authzTypeLine.join(","));

        var reportDateLine = ['Data Raport', Formatter.formatDatetoRO(dayjs().format())];
        csv_data.push(reportDateLine.join(","));

        csv_data.push(csvEmpty.join(",")); 
        csv_data.push(csvEmpty.join(",")); 

        // Combine each column value with comma
        csv_data.push(csvHeader.join(","));    

        for (var i = 0; i < report.length; i++) {
            const reportLine = report[i];

            var csvRow = [];
            csvRow.push(reportLine.cnp);
            csvRow.push(reportLine.lastName);
            csvRow.push(reportLine.firstName);
            csvRow.push(reportLine.occupationCORdescription);
            csvRow.push(reportLine.certificateNo);
            csvRow.push( Formatter.formatDatetoRO(reportLine.dateCertificate) );
            csvRow.push(TypeConvertor.getAuthzInternalName(reportLine.authInternal));
            csvRow.push( Formatter.formatDatetoRO(reportLine.dateMaturity) );
            csvRow.push(TypeConvertor.getCimStatusName(reportLine.employeeContractStatus));

            csv_data.push(csvRow.join(",")); 
        }
        csv_data.push(csvEmpty.join(",")); 

        // combine each row data with new line character
        csv_data = csv_data.join('\n');    

        return csv_data;

    }

    return (
        <React.Fragment>
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={8}>
                    {reportEmployerName} - {reportWorksiteName}
                </Grid>
                <Grid item xs={4}>
                    <Box display="flex" justifyContent="flex-end" alignItems="flex-end">
                        <Link onClick={() => downloadRaport()}>Salveaza Raport<FileDownloadIcon /></Link>
                    </Box>
                </Grid>
            </Grid>

            <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2  }}>
                <DataGrid
                    rows={report}
                    columns={columns}
                    initialState={{
                        sorting: { sortModel: [{ field: 'lastName', sort: 'asc' }] }
                    }}                            
                    sx={{ overflowX: 'scroll' }}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    checkboxSelection={false}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                />
            </Box>
        </React.Fragment>
    );
}

export default ReportAuthzInternal;